import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';

const SalesHub = lazy(() => import('../pages/sales/SalesHub'));
const EnquiryForm = lazy(() => import('../pages/sales/EnquiryForm'));
const EnquiryDetail = lazy(() => import('../pages/sales/EnquiryDetail'));
const QuotationBuilder = lazy(() => import('../pages/sales/QuotationBuilder'));
const QuotationDetail = lazy(() => import('../pages/sales/QuotationDetail'));
const PurchaseOrderForm = lazy(() => import('../pages/sales/PurchaseOrderForm'));
const PurchaseOrderDetail = lazy(() => import('../pages/sales/PurchaseOrderDetail'));

const p = (module, action, el) => <ProtectedRoute module={module} action={action}>{el}</ProtectedRoute>;

export const salesRoutes = (
  <>
    <Route path="/sales" element={<SalesHub />} />
    <Route path="/sales/enquiries/new" element={p('enquiries', 'add', <EnquiryForm />)} />
    <Route path="/sales/enquiries/:id" element={p('enquiries', 'view', <EnquiryDetail />)} />
    <Route path="/sales/enquiries/:id/edit" element={p('enquiries', 'change', <EnquiryForm />)} />
    <Route path="/sales/quotations/new" element={p('quotations', 'add', <QuotationBuilder />)} />
    <Route path="/sales/quotations/:id" element={p('quotations', 'view', <QuotationDetail />)} />
    <Route path="/sales/quotations/:id/edit" element={p('quotations', 'change', <QuotationBuilder />)} />
    <Route path="/sales/purchase-orders/new" element={p('purchase_orders', 'add', <PurchaseOrderForm />)} />
    <Route path="/sales/purchase-orders/:id" element={p('purchase_orders', 'view', <PurchaseOrderDetail />)} />
    <Route path="/sales/purchase-orders/:id/edit" element={p('purchase_orders', 'change', <PurchaseOrderForm />)} />
  </>
);

export default salesRoutes;
